<seriesSheetView *ngIf="sheet_ready" [series]="series" [process]="process" (refreshInner)="refresh()"></seriesSheetView>
